import { render, staticRenderFns } from "./modal-brief-create.vue?vue&type=template&id=6897f2fa&"
import script from "./modal-brief-create.vue?vue&type=script&lang=js&"
export * from "./modal-brief-create.vue?vue&type=script&lang=js&"
import style0 from "./modal-brief-create.vue?vue&type=style&index=0&id=6897f2fa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports